import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MatTabsModule } from "@angular/material/tabs";
import { RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-in-play",
  templateUrl: "./in-play.component.html",
  styleUrl: "./in-play.component.scss",
  imports: [MatTabsModule, RouterLink, RouterLinkActive, RouterOutlet, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InPlayComponent {
  navItems = [
    {
      label: "In-Play",
      path: [
        "/app/main",
        {
          outlets: {
            navigation: ["sports"],
            content: ["in-play", "current"],
          },
        },
      ],
    },
    {
      label: "Today",
      path: [
        "/app/main",
        {
          outlets: {
            navigation: ["sports"],
            content: ["in-play", "today"],
          },
        },
      ],
    },
    {
      label: "Tomorrow",
      path: [
        "/app/main",
        {
          outlets: {
            navigation: ["sports"],
            content: ["in-play", "tomorrow"],
          },
        },
      ],
    },
  ];
}
